document.addEventListener("DOMContentLoaded", function () {

  const texts = document.querySelectorAll(".read-more-text");

  texts.forEach(function(text){

    const words = text.innerText.trim().split(/\s+/);

    if(words.length > 10){

      const fullText = text.innerText;
      const shortText = words.slice(0,10).join(" ") + "...";

      text.innerText = shortText;

      const btn = text.nextElementSibling;

      if(btn){
        btn.style.display = "inline-block";

        btn.addEventListener("click", function(){

          if(btn.innerText === "Read More"){
            text.innerText = fullText;
            btn.innerText = "Read Less";
          }else{
            text.innerText = shortText;
            btn.innerText = "Read More";
          }

        });
      }

    }else{

      const btn = text.nextElementSibling;
      if(btn){
        btn.style.display = "none";
      }

    }

  });

});